import React,{useRef, useState, useEffect} from "react";
import { Select, Form, Col, Row } from "react-bootstrap";
import ProgressBar from 'react-bootstrap/ProgressBar';
import atlasApi from "../utils/atlasapi";
import { Book, CircleNotch   } from "@phosphor-icons/react";
import DoNowButton from "../components/DoNowButton";


class OwnerFetcher extends React.Component {

	
	constructor(props) {
		super(props);
		
		this.state = {
			listening: false,
			total:0,
			current:0,
			variant:'success',
			progressText:false
		};
		
		
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
	}
	async handleChange(e){
		

	};

	
	componentDidUpdate(prevProps) {
	// Typical usage (don't forget to compare props):

		
	}
	componentDidMount(prevProps) {
	// Typical usage (don't forget to compare props):

		this.fetchProgress();

		
	}
	componentWillUnmount() {
		this?.stream?.close();

	}
	fetchProgress(){
		if(!this.props.workMode.obj.tc.scenario)
			return;
		const {QN, dialogs, getters} = this.props.context;
		
		this?.stream?.close();
		
		
		this.stream = atlasApi.requestProgress(this.props.workMode.label.toLowerCase(), this.props.workMode.obj.tc.scenario.projectid);
		
		this.stream.on("progress", data => {
			try {
				const json = JSON.parse(data);
				this.updateStatus({
					total:json.total, 
					current:json.processed,
					progressText: json.processed+'/'+json.total+' property units fetched...'
				});
				
				
				if(json.currentProperty && json.data[json.currentProperty]){
					this.props.workMode.obj.handleFetchOwner(json.data[json.currentProperty], json.currentProperty);
				}
				
			} catch {
				console.log("Raw SSE message:", data);
			}
		});
		this.stream.on("completed", data => {
			try {
				const json = JSON.parse(data);
				//this.props.workMode.obj.handleFetchBulkOwners(json.data, this.props.unknowns);
				
				setTimeout(()=>{
					QN.current.show(json.total+" landowners were fetched from landbook");
					this.updateStatus({listening:false, progressText:false})
				}, 2000);
			
			} catch {
				
			}
			
		});
		  
		this.stream.on("open", () => {
			
			this.updateStatus({
				listening:true,
				progressText: 'Fetching owners...'
			});
		});


		this.stream.on("error", (err) => {
			
		}); 
		  
		this.stream.connect();
	}
	now(){
		if(!this.state.listening || !this.state.total)
			return 0;
		return Math.round(this.state.current/this.state.total *100);
	}
	
	
	render() {
		
		
		
		return (

			<div className="ownerfetcher">
		
				{!!this.props.unknowns.length && !this.state.progressText &&
				<DoNowButton 
					iconIdle={<Book size={16} />}
					btnClassName="btn-land-actions land-book"
					onClick={()=>{
						return this.props.workMode.obj.fetchBulkOwners(this.props.unknowns);
					}}
					onFinish={(owners)=>{
						
					}}
					text={'Fetch '+this.props.unknowns.length+' owner(s) from Land Book '+this.props.workMode.obj.fetchOwnersCost(this.props.unknowns.length)}
				/>
				}

				{this.state.listening && this.state.progressText &&
				<div className="request-progress">
					{this.state.progressText}
					<CircleNotch className="spin" size={16} />
				</div>
				}
			</div>

		);
	}
}

export default OwnerFetcher;